import React, { SVGProps } from 'react';

const StatusFilterIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M3 3H14V8H3V3Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 8H18V13H3V8Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3 13H12V18H3L3 13Z" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default StatusFilterIcon;
